import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component, createRef } from 'react';
import { NoteTextArea, NoteFooter, NoteContainer, CharCounter } from './note.styles';
import { CloseButton } from '../../buttons/close_button';
import Button from '../../buttons/button';
import { getStringLength } from '../../../util/get_string_length';
const ACTIVE_CONTAINER_HEIGHT = 200;
export default class Note extends Component {
    constructor(props) {
        super(props);
        this.textareaRef = createRef();
        this.wrapperRef = createRef();
        this.handleClickOutside = (e) => {
            if (this.state.isFocused &&
                !!this.wrapperRef.current &&
                !this.wrapperRef.current.contains(e.target)) {
                this.saveNote();
                this.handleFocusLost();
            }
        };
        this.fitStaticHeightToContent = () => {
            if (this.props.disableAutoGrow) {
                return;
            }
            this.setState({ activeHeight: 1 }, () => {
                const scrollHeight = this.textareaRef.current
                    ? this.textareaRef.current.scrollHeight
                    : ACTIVE_CONTAINER_HEIGHT;
                const activeHeight = scrollHeight > ACTIVE_CONTAINER_HEIGHT ? ACTIVE_CONTAINER_HEIGHT : scrollHeight;
                this.setState({ activeHeight: activeHeight });
            });
        };
        this.handleFocusLost = () => {
            this.setState({ isFocused: false }, this.fitStaticHeightToContent);
        };
        this.handleFocus = () => {
            if (this.state.isFocused) {
                return;
            }
            this.setState({
                noteDraft: this.state.note,
                isFocused: true,
            });
        };
        this.handleBlur = (e) => {
            const goingTo = e.relatedTarget;
            if (goingTo) {
                const { current } = this.wrapperRef;
                const inParent = current && current.contains(goingTo);
                if (!inParent) {
                    this.saveNote();
                    this.handleFocusLost();
                }
            }
        };
        this.saveNote = () => {
            const updatedNote = this.state.noteDraft ? this.state.noteDraft.trim() : '';
            this.setState({ note: updatedNote });
            this.props.onSave(updatedNote);
        };
        this.handleSaveClick = () => {
            this.saveNote();
            this.handleFocusLost();
        };
        this.handleCancelClick = () => {
            this.handleFocusLost();
        };
        this.isAtCharLimit = (count) => {
            return count >= this.charLimit;
        };
        this.handleInputChange = (e) => {
            let noteDraft = e.target.value;
            const charCount = this.getCharCount(noteDraft);
            const isTooLong = this.isAtCharLimit(charCount);
            if (isTooLong) {
                noteDraft = noteDraft.substring(0, this.charLimit);
            }
            this.setState({
                noteDraft: noteDraft,
                noteLimitReached: isTooLong,
            }, this.fitStaticHeightToContent);
        };
        this.getCharCount = (note) => {
            return getStringLength(note || '');
        };
        this.renderCharCount = () => {
            const { noteDraft } = this.state;
            if (!noteDraft) {
                return null;
            }
            return `${this.getCharCount(noteDraft)}/${this.charLimit}`;
        };
        this.charLimit = this.props.characterLimit;
        this.state = {
            note: '',
            noteDraft: '',
            noteLimitReached: false,
            activeHeight: this.props.disableAutoGrow ? undefined : ACTIVE_CONTAINER_HEIGHT,
            isFocused: false,
        };
    }
    componentDidMount() {
        this.setState({
            note: this.props.noteText,
            noteDraft: this.props.noteText,
        }, this.fitStaticHeightToContent);
        if (!this.props.disableEditing) {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.noteText !== this.props.noteText && !!this.props.noteText) {
            this.setState({ note: this.props.noteText });
        }
    }
    componentWillUnmount() {
        if (!this.props.disableEditing) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            if (this.props.noteText !== this.state.noteDraft) {
                this.saveNote();
            }
        }
    }
    render() {
        const { note, noteDraft, isFocused, activeHeight, noteLimitReached } = this.state;
        const { disableEditing } = this.props;
        return (_jsxs(NoteContainer, { style: this.props.style, ref: this.wrapperRef, children: [_jsx(NoteTextArea, { ref: this.textareaRef, value: isFocused ? noteDraft : note, onChange: this.handleInputChange, onFocus: this.handleFocus, onBlur: this.handleBlur, isFocused: disableEditing ? false : isFocused, activeHeight: activeHeight, placeholder: disableEditing ? '-- N/A --' : `${this.props.placeholderText}`, maxLength: this.charLimit, disabled: disableEditing, 
                    // Keeps textarea white when not focused when rendered as a RoomNote (for live call view)
                    style: this.props.textareaStyle && this.props.textareaStyle }), isFocused && (_jsxs(NoteFooter, { children: [_jsx(Button, { variant: "primary", onBlur: this.handleBlur, onClick: this.handleSaveClick, children: "Save" }), _jsx(CloseButton, { label: "cancel note edit", onBlur: this.handleBlur, onClick: this.handleCancelClick }), _jsx(CharCounter, { noteLimitReached: noteLimitReached, characterLimit: this.charLimit, charCount: this.getCharCount(noteDraft), children: this.renderCharCount() })] }))] }));
    }
}
//# sourceMappingURL=note.js.map